import { Fragment } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { ControlesLinha, ProcessoInput } from '../../components/RelatorioCivelComponents';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step03Contestacao(props: RelatorioCivelStepProps) {
  const {
    novoProcessoContestacao,
    setNovoProcessoContestacao,
    adicionarProcesso,
    quantidadeLinhas,
    setQuantidadeLinhas,
    adicionarMultiplasLinhas,
    isViewMode,
    formData,
    renderTabelaProcessos,
  } = props;

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-bold">N.° do Processo</Form.Label>
              <ProcessoInput
                value={novoProcessoContestacao}
                onChange={setNovoProcessoContestacao}
                onAdicionar={() => adicionarProcesso('contestacao', novoProcessoContestacao, setNovoProcessoContestacao)}
              />
              <Form.Text className="text-muted">
                Pressione Enter ou clique em Adicionar para incluir o processo na lista
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      )}

      {!isViewMode && (
        <ControlesLinha
          quantidade={quantidadeLinhas.contestacao}
          onDecrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, contestacao: Math.max(1, prev.contestacao - 1) }))
          }
          onIncrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, contestacao: Math.min(50, prev.contestacao + 1) }))
          }
          onQuantidadeChange={(value: number) => setQuantidadeLinhas((prev) => ({ ...prev, contestacao: value }))}
          onAdicionar={() => adicionarMultiplasLinhas('contestacao')}
          totalLabel="Total de Processos"
          totalCount={formData.contestacao.processos.length}
        />
      )}

      {renderTabelaProcessos('contestacao', formData.contestacao.processos)}
    </Fragment>
  );
}

